import { render, staticRenderFns } from "./CheckPenaltiesButton.vue?vue&type=template&id=7d877a75&scoped=true&"
import script from "./CheckPenaltiesButton.vue?vue&type=script&lang=js&"
export * from "./CheckPenaltiesButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d877a75",
  null
  
)

export default component.exports